import { combineReducers } from "redux"
import userReducer from "./user"
import { UserState } from "./user/reducer"

export interface ProfessionalsState {
	user: UserState
}

const professionalsReducer = combineReducers({
	user: userReducer,
})

export default professionalsReducer
